import React from 'react';
import { FileIconBase } from './_base';
const GenericFileIcon = (props) => (React.createElement(FileIconBase, Object.assign({}, props, { defaultColor: "#6B7280", label: "FILE" })));
export default GenericFileIcon;
